import { Text } from '@kanda-libs/ks-design-library';

import { FormattedJob } from 'types';

import Container from './Header-container';
import { Bullets, Logo } from './components';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  job?: FormattedJob;
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ job, isLoading }: ViewComponentProps) => (
  <Container job={job} isLoading={isLoading}>
    {({ logo, title, items, reference }) => (
      <div className="flex flex-col">
        <Logo isLoading={isLoading} {...logo} />
        <Text
          text={title}
          isLoading={isLoading}
          className="text-20-24-em text-neutral-900 mb-4"
        />
        <Bullets items={items} isLoading={isLoading} />
        <Text
          text={reference}
          isLoading={isLoading}
          className="text-12-18 text-neutral-600"
        />
        <div className="mb-8 md:my-8 border-0 md:border-t border-neutral-300" />
      </div>
    )}
  </Container>
);

ViewComponent.displayName = 'JobSidebar-Header-view';

ViewComponent.defaultProps = {
  job: undefined,
  isLoading: false,
};

export default ViewComponent;
